import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Spinner from '../components/Spinner';
import { getModels } from '../services/api';
import FileUploadDD from '../components/DragDropFile';
import { useAuth0 } from '@auth0/auth0-react';

const ModelCard = ({ model, index, onClick }) => {

  return (
    <motion.div
      onClick={onClick}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      whileHover={{ y: -5, transition: { duration: 0.2 } }}
      className="bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-xl shadow-sm overflow-hidden cursor-pointer"
    >
      <div className="h-2 bg-gradient-to-r from-[#CE0E2D] to-[#38424D]"></div>
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-800 dark:text-white">{model.name}</h3>
          <span className={`px-2 py-1 text-xs rounded-full ${model.status === 'Active' ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400' :
            model.status === 'In Training' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400' :
              'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400'
            }`}>
            {model.status}
          </span>
        </div>
        <p className="text-gray-600 dark:text-gray-300 text-sm mb-4 line-clamp-2">{model.description}</p>
        <div className="flex justify-between items-center">
          {/* <div>
            <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">Accuracy</p>
            <div className="flex items-center">
              <div className="w-16 h-2 bg-gray-200 dark:bg-gray-600 rounded-full mr-2">
                <div
                  className={`h-full rounded-full ${model.accuracy > 85 ? 'bg-green-500' :
                    model.accuracy > 70 ? 'bg-blue-500' :
                      'bg-yellow-500'
                    }`}
                  style={{ width: `${model.accuracy}%` }}
                ></div>
              </div>
              <span className="text-xs text-gray-700 dark:text-white">{model.accuracy}%</span>
            </div>
          </div> */}
          {/* <div className="text-xs text-gray-500 dark:text-gray-400">
            Updated: {model.lastUpdated}
          </div> */}
        </div>
      </div>
    </motion.div>
  );
};

const ModelsPage = () => {
  const { logout } = useAuth0();
  const navigate = useNavigate();
  const [filter, setFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [modelList, setModelList] = useState(null);

  useEffect(() => {
    const getModelsList = async () => {
      try {
        const mData = await getModels(logout);
        setModelList(mData);
        console.log(mData);

      } catch (error) {
        console.error(`Error fetching health for model:`, error);

        // Track error in Clarity
        // trackClarityEvent('model_health_error', {
        //   modelId: modelId,
        //   modelType: key,
        //   errorMessage: error.message
        // });


      }
    }

    getModelsList()

  }, [])

  // Placeholder data for models
  const models = [
    {
      id: 1,
      name: 'Lookalike Model',
      description: 'A sophisticated tool designed to identify potential high-value customers by analyzing existing transaction data. It processes your current customer information to pinpoint individuals who exhibit purchasing behaviors similar to your most valuable clients.',
      accuracy: 92,
      status: 'Active',
      lastUpdated: '2025-05-16',
      type: 'acquisition'
    },
    {
      id: 2,
      name: 'Recency Frequency Monetary Model',
      description: 'Recency value refers to the amount of time since a customers last interaction with a brand, which can include their last purchase, a visit to a website, use of a mobile app, a like on social media and more.',
      accuracy: 88,
      status: 'Active',
      lastUpdated: '2025-05-16',
      type: 'analytics'
    },
    {
      id: 3,
      name: 'Customer Life Time Value Model',
      description: 'To predict the total revenue a customer is expected to generate throughout their entire relationship with a business. This allows companies to identify and prioritize high-value customers, optimize marketing spend, and personalize customer experiences.',
      accuracy: 76,
      status: 'In Training',
      lastUpdated: '2025-06-20',
      type: 'attribution'
    },
    {
      id: 4,
      name: 'Multi-Touch Attribution Model',
      description: 'A recommendation system is an artificial intelligence or AI algorithm, usually associated with machine learning, that uses Big Data to suggest or recommend additional products to consumers.',
      accuracy: 94,
      status: 'Active',
      lastUpdated: '2025-05-16',
      type: 'attribution'
    },
    {
      id: 5,
      name: 'Voice of Customer Analytics',
      description: 'Voice of Customer (VoC) Analytics captures and analyzes customer feedback from various sources to uncover insights about customer needs, preferences, and experiences. It helps businesses enhance products, services, and overall customer satisfaction.',
      accuracy: 65,
      status: 'Draft',
      lastUpdated: '2025-06-10',
      type: 'retention'
    },
    {
      id: 6,
      name: 'Marketing Mix Modeling Analysis',
      description: 'Marketing Mix Modeling Analysis evaluates the performance and impact of marketing efforts across various media channels to optimize reach, engagement, and ROI. It helps identify the most effective platforms and strategies for audience targeting and campaign success.',
      accuracy: 89,
      status: 'Active',
      lastUpdated: '2025-06-05',
      type: 'analytics'
    },
    {
      id: 7,
      name: 'Email Validation',
      description: 'Email Validation description.',
      accuracy: 90,
      status: 'Active',
      lastUpdated: '2025-06-05',
      type: 'utility'
    },
    {
      id: 8,
      name: 'Analytical File',
      description: 'Analytical File description.',
      accuracy: 93,
      status: 'Active',
      lastUpdated: '2025-06-05',
      type: 'utility'
    },
    {
      id: 9,
      name: 'Customer Identity Duplications',
      description: 'Customer Identity Duplications description.',
      accuracy: 93,
      status: 'Active',
      lastUpdated: '2025-07-11',
      type: 'analytics'
    },
    {
      id: 10,
      name: 'Data Quality Model',
      description: 'Data Quality Model description.',
      accuracy: 91,
      status: 'Active',
      lastUpdated: '2025-08-06',
      type: 'analytics'
    }
  ];

  // (modelList?.length ? modelList : models)
  const filteredModels = (modelList)?.filter(model => {
    const typeMatch = filter === 'all' || model.type === filter;
    const statusMatch = statusFilter === 'all' || model.status === statusFilter;
    return typeMatch && statusMatch;
  });

  const getModelById = (id) => {
    return modelList?.find((model) => model.id === id);
  };


  const modelTypes = ['Customer Acquisition', 'Marketing Analytics', 'Channel Attribution', 'Campaign Analytics', 'Retention', 'Valuation'];
  const statusTypes = ['Active', 'In Training', 'Draft'];
  const primaryButtonClass = "px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#0062cc] hover:bg-[#0052ac] disabled:opacity-50 disabled:cursor-not-allowed";


  return (
    <div className="pt-24 pb-16 bg-gray-50 dark:bg-gray-900 min-h-screen">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="container mx-auto px-4"
      >
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white">Analytics Models</h1>
            <p className="text-gray-600 dark:text-gray-300 mt-1">Discover and manage your analytics models</p>
          </div>
          {/* <div className="mt-4 md:mt-0">
            <button */}
          {/* onClick={() => {/* Create new model functionality */}
          {/* className="px-4 py-2 bg-[#CE0E2D] rounded-lg text-sm text-white hover:bg-primary3 flex items-center"
            >
              <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              New Model
            </button>
          </div> */}
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 p-4 mb-8">
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => setFilter('all')}
              className={`px-4 py-2 rounded-lg text-sm ${filter === 'all'
                ? 'bg-[#CE0E2D] text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
            >
              All Models
            </button>
            <button
              onClick={() => setFilter('acquisition')}
              className={`px-4 py-2 rounded-lg text-sm ${filter === 'acquisition'
                ? 'bg-[#CE0E2D] text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
            >
              Acquisition
            </button>
            <button
              onClick={() => setFilter('attribution')}
              className={`px-4 py-2 rounded-lg text-sm ${filter === 'attribution'
                ? 'bg-[#CE0E2D] text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
            >
              Attribution
            </button>
            <button
              onClick={() => setFilter('analytics')}
              className={`px-4 py-2 rounded-lg text-sm ${filter === 'analytics'
                ? 'bg-[#CE0E2D] text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
            >
              Analytics
            </button>
            <button
              onClick={() => setFilter('retention')}
              className={`px-4 py-2 rounded-lg text-sm ${filter === 'retention'
                ? 'bg-[#CE0E2D] text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
            >
              Retention
            </button>

            <button
              onClick={() => setFilter('utility')}
              className={`px-4 py-2 rounded-lg text-sm ${filter === 'utility'
                ? 'bg-[#CE0E2D] text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
            >
              Utility
            </button>


            <div className="flex-grow"></div>
            <button
              onClick={() => setStatusFilter('Active')}
              className={`px-4 py-2 rounded-lg text-sm ${statusFilter === 'Active'
                ? 'bg-green-500 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
            >
              Active
            </button>
            <button
              onClick={() => setStatusFilter('In Training')}
              className={`px-4 py-2 rounded-lg text-sm ${statusFilter === 'In Training'
                ? 'bg-blue-500 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
            >
              In Training
            </button>
            <button
              onClick={() => setStatusFilter('Draft')}
              className={`px-4 py-2 rounded-lg text-sm ${statusFilter === 'Draft'
                ? 'bg-yellow-500 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
            >
              Draft
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredModels?.length > 0 ? (
            filteredModels?.map((model, index) => (

              <ModelCard
                key={model.id}
                model={model}
                index={index}
                onClick={() => {
                  const extraData = getModelById(model.id);
                  console.log('exre', extraData);

                  if (!extraData) {
                    console.warn('Model data not loaded yet or not found:', model.id);
                    // return;
                  }
                  navigate(model.type === 'utility' ? `/utility/${model.id}` : `/model/${model.id}`, {
                    state: { extraData },
                  });
                }}

              // onClick={() => navigate(model.type == 'utility' ? `/utility/${model.id}` : `/model/${model.id}`,
              //   {
              //     state: {
              //       extraData: getModelById(model.id),
              //     },
              //   }
              // )}
              />
            ))
          )
            : filter === 'email' ? (<div className="col-span-full text-center py-12">

              <h4 className="text-md font-semibold text-gray-800 dark:text-white"> Upload Email validation file</h4>
              <p className="text-sm text-gray-600 dark:text-gray-300">Select your testing data file (.csv expected).</p>
              <div className="flex justify-center mt-10">
                <input
                  type="file"
                  accept=".csv"
                  onChange={(e) => { }}
                  className=" block text-sm text-gray-500 dark:text-gray-400 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border file:border-gray-300 dark:file:border-gray-600 file:text-sm file:font-semibold file:bg-gray-100 dark:file:bg-gray-700 file:text-gray-700 dark:file:text-gray-300 hover:file:bg-gray-200 dark:hover:file:bg-gray-600"
                />
              </div>
              <button
                onClick={() => { }}
                // disabled={!testFile || isLoading}
                className={primaryButtonClass}
              >
                {true ? <><Spinner size="xs" className="mr-2" /> Uploading...</> : 'Upload Testing Data'}
              </button>
            </div>)
              : filter === 'files' ? (
                <div className='col-span-full flex items-center justify-center text-center h-64'>
                  <FileUploadDD />
                </div>
              )
                : (
                  <div className="col-span-full text-center py-12">
                    <p className="text-gray-500">No models match your filter criteria.</p>
                    <button
                      onClick={() => setFilter('all')}
                      className="mt-4 px-4 py-2 bg-gray-100 rounded-lg text-sm text-gray-600 hover:bg-gray-200"
                    >
                      Show All Models
                    </button>
                  </div>
                )}
        </div>

        {
          filteredModels?.length > 0 && (
            <div className="mt-12 bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 p-6">
              <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-4">Quick Model Comparison</h2>
              <div className="overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr className="bg-gray-50 dark:bg-gray-700">
                      <th className="py-3 pl-4 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Model Name</th>
                      <th className="py-3 px-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Type</th>
                      <th className="py-3 px-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Status</th>
                      <th className="py-3 px-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Accuracy</th>
                      {/* <th className="py-3 pr-4 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Last Updated</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredModels.map((model, index) => (
                      <tr
                        key={model.id}
                        className="hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-100 dark:border-gray-700 cursor-pointer"
                        onClick={() => navigate(`/model/${model.id}`)}
                      >
                        <td className="py-3 pl-4">{model.name}</td>
                        <td className="py-3 px-2 capitalize">{model.type}</td>
                        <td className="py-3 px-2">
                          <span className={`px-2 py-1 text-xs rounded-full ${model.status === 'Active' ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400' :
                            model.status === 'In Training' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400' :
                              'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400'
                            }`}>
                            {model.status}
                          </span>
                        </td>
                        <td className="py-3 px-2">
                          <div className="flex items-center">
                            <div className="w-24 h-2 bg-gray-200 dark:bg-gray-600 rounded-full mr-2">
                              <div
                                className={`h-full rounded-full ${model.accuracy > 85 ? 'bg-green-500' :
                                  model.accuracy > 70 ? 'bg-blue-500' :
                                    'bg-yellow-500'
                                  }`}
                                style={{ width: `${model.accuracy}%` }}
                              ></div>
                            </div>
                            <span className="text-sm text-gray-800 dark:text-white">{model.accuracy}%</span>
                          </div>
                        </td>
                        {/* <td className="py-3 pr-4 text-right text-gray-500 dark:text-gray-400">{model.lastUpdated}</td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )
        }
      </motion.div >
    </div >
  );
};

export default ModelsPage; 